import * as React from 'react'

interface ILazyLoadErrorBoundaryProps {
  errorIndicator: React.ReactElement
  children?: React.ReactNode
}

interface ILazyLoadErrorBoundaryState {
  hasError: boolean
}

export class LazyLoadErrorBoundary extends React.Component<
  ILazyLoadErrorBoundaryProps,
  ILazyLoadErrorBoundaryState
> {
  public static getDerivedStateFromError() {
    return {hasError: true}
  }

  constructor(props) {
    super(props)
    this.state = {hasError: false}
  }

  public render() {
    if (this.state.hasError) {
      return this.props.errorIndicator
    }

    return this.props.children
  }
}
